export const directo_hora = [
  {
    label: "Id",
    name: "iddirecto_hora",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Personal",
    name: "idpersonal",
    type: "personal",
    showOnList: true,
  },
  {
    label: "Fecha de inicio",
    name: "fecha_ini",
    type: "DATE",
    allowNull: false,
    showOnList: true,
  },
  {
    label: "Moneda",
    name: "idmoneda",
    type: "moneda",
    showOnList: true,
  },
  {
    label: "Directo hora",
    name: "montoxhora",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    min: 0,
    step: 0.01,
    decimals: 2,
    onChange: (record) => {
      record.costo_hora =
        (parseFloat(record.montoxhora) || 0) +
        (parseFloat(record.indirecto_hora) || 0);
      record.costo_hora_comparativo =
        record.cotizacion > 0
          ? +(record.costo_hora / record.cotizacion).toFixed(2)
          : record.costo_hora_comparativo;
    },
  },
  {
    label: "Indirecto hora",
    name: "indirecto_hora",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    min: 0,
    step: 0.01,
    decimals: 2,
    onChange: (record) => {
      record.costo_hora =
        (parseFloat(record.montoxhora) || 0) +
        (parseFloat(record.indirecto_hora) || 0);
      record.costo_hora_comparativo =
        record.cotizacion > 0
          ? +(record.costo_hora / record.cotizacion).toFixed(2)
          : record.costo_hora_comparativo;
    },
  },
  {
    label: "Costo hora",
    name: "costo_hora",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    readonly: true,
    currency: true,
    decimals: 2,
  },
  {
    label: "Cotización",
    name: "cotizacion",
    type: "DECIMAL",
    step: 0.01,
    onChange: (record) => {
      record.costo_hora_comparativo =
        record.cotizacion > 0 ? +(record.costo_hora / record.cotizacion).toFixed(2) : 0;
    },
  },
  {
    label: "Costo hora comparativo (USD)",
    name: "costo_hora_comparativo",
    type: "DECIMAL",
    allowNull: true,
    showOnList: true,
    min: 0,
    step: 0.01,
    currency: true,
    decimals: 2,
    onChange: (record) => {
      record.cotizacion =
        record.costo_hora_comparativo > 0
          ? +(record.costo_hora / record.costo_hora_comparativo).toFixed(2)
          : 0;
    },
  },
];
